// Compress an image File to fit within max dimensions and JPEG quality.
// Returns the original File if compression fails or the file isn't an image.
export async function compressImageIfNeeded(file, { maxDim = 2400, quality = 0.85, thresholdBytes = 2 * 1024 * 1024 } = {}) {
  if (!file || !file.type?.startsWith("image/") || file.size <= thresholdBytes) return file;
  if (file.type === "image/gif" || file.type === "image/svg+xml") return file;
  try {
    const bitmap = await createImageBitmap(file);
    let { width, height } = bitmap;
    const longest = Math.max(width, height);
    if (longest > maxDim) {
      const scale = maxDim / longest;
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }
    const canvas = document.createElement("canvas");
    canvas.width = width; canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, width, height);
    const targetType = file.type === "image/png" ? "image/jpeg" : file.type;
    const blob = await new Promise((res) => canvas.toBlob(res, targetType, quality));
    if (!blob || blob.size >= file.size) return file;
    const newName = file.name.replace(/\.(png|jpg|jpeg|webp)$/i, ".jpg");
    return new File([blob], newName, { type: targetType, lastModified: Date.now() });
  } catch {
    return file;
  }
}
